import React, {forwardRef} from 'react';

import {Icon} from '#component/base/Icon';
import {Text} from '#component/base/Text';
import {sprinkles} from '#style/sprinkles';

import {ListItemComponent, ListItemProps} from './ListItem.types';

import {rootStyles} from './ListItem.css';

export const ListItem: ListItemComponent = forwardRef(
  <T extends React.ElementType = 'a'>(
    {as, className, icon, label, variant = 'primary', ...restProps}: ListItemProps<T>,
    ref?: PolymorphicRef<T>,
  ) => {
    const Component = as || 'a';

    return (
      <Component className={`${rootStyles({variant})} ${className}`} ref={ref} {...restProps}>
        {icon && <Icon name={icon} color="dustyGray" weight="bold" />}

        <Text className={sprinkles({grow: 1})} color="inherit" textAlign="left" variant="button">
          {label}
        </Text>

        <Icon color="dustyGray" name="CaretRight" weight="bold" />
      </Component>
    );
  },
);
